import moment from 'moment';
import { apiGateway } from '../api';

async function getTypesGuides() {
    try {
        const response = await apiGateway.get('/guias/tipos');

        return response.data.tiposGuia;
    } catch (error) {
        return error;
    }
}

async function getGuides(carteirinha, at, from, guidance, types) {
    const body = {
        cabecalho: {
            canal: 'M',
            codigoEmpresaOrigem: '1',
            divisaoNegocio: '1',
            empresaOrigemAtendimento: '1',
            origemContrato: '1',
            tipoContrato: '1',
            token: '1',
            unidadeNegocio: '1',
        },
        carteirinha,
        codigoCredenciado: ' ',
        dataFinal: moment(from.value).format('DD/MM/YYYY'),
        dataInicial: moment(at.value).format('DD/MM/YYYY'),
        nomeBeneficiario: ' ',
        numeroGuia: guidance.value,
        perfil: 'BENEFICIARIO',
        tipoGuia: types.value,
    };

    try {
        const response = await apiGateway.post('/guias/pesquisar', body);

        return response.data.capaGuiaMedicaList;
    } catch (error) {
        return error;
    }
}

async function getDownloadGuide(carteirinha, guidance, types) {
    const body = {
        cabecalho: {
            canal: 'M',
            codigoEmpresaOrigem: '1',
            divisaoNegocio: '1',
            empresaOrigemAtendimento: '1',
            origemContrato: '1',
            tipoContrato: '1',
            token: '1',
            unidadeNegocio: '1',
        },
        carteirinha,
        codigoCredenciado: ' ',
        nomeBeneficiario: ' ',
        numeroGuia: guidance,
        perfil: 'BENEFICIARIO',
        tipoGuia: types.value,
    };

    try {
        const response = await apiGateway.post('/guias/pesquisar/gerar-pdf', body, {
            responseType: 'blob',
        });

        return response.data;
    } catch (error) {
        return error;
    }
}

export { getTypesGuides, getGuides, getDownloadGuide };
